import React from "react";

import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as PlusIcon } from "src/images/plus-alt.svg";

interface UploadBriefButtonProps {
  onClick: () => void;
  isDisabled?: boolean;
}

export default function UploadBriefButton({
  onClick,
  isDisabled,
}: UploadBriefButtonProps) {
  return (
    <Button variant="bare" onClick={onClick} size="thin" disabled={isDisabled}>
      <PlusIcon />
      <IDHFormattedMessage
        id="ws_upload_file"
        defaultMessage="Upload the file"
      />
    </Button>
  );
}
